module.exports = __webpack_public_path__ + "static/images/dynamic-pricing.55b27ba66470c9ed55cf0b881a47deab.svg";